export default "__VITE_ASSET__COaFGXU0__"